export default {
  'employee.status.activated': '已激活',
  'employee.status.deactivated': '已冻结',

  'device.status.online': '在线',
  'device.status.offline': '离线',
  'device.status.active': '已激活',
  'device.status.deactive': '已冻结',
};
